import type { UnsortedRecord } from "@/lib/api";
import { Box, Text } from "@okshaun/components";
import { css } from "@styled-system/css";
import { RailSection } from "./rail-section";

const chip = css({
  fontSize: "12",
  lineHeight: "tight",
  color: "text.subtle",
  px: "8",
  py: "4",
  border: "default",
  borderRadius: "999",
});

export function TriageRail({ items }: { items: UnsortedRecord[] }) {
  return (
    <RailSection title="Needs triage" meta={`${items.length} unsorted`}>
      <Box display="flex" flexWrap="wrap" gap="6" p="6">
        {items.length === 0 && (
          <Text textStyle="mono.sm" color="text.subtlest">
            Everything is sorted.
          </Text>
        )}
        {items.map((u) => (
          <span key={u.slug} className={chip}>
            {u.name}
          </span>
        ))}
      </Box>
      <Text textStyle="body.sm" color="text.subtlest" px="12" pb="6">
        These carry{" "}
        <Text as="span" textStyle="mono.xs">
          status: unsorted
        </Text>{" "}
        in the vault. Nothing here is a task.
      </Text>
    </RailSection>
  );
}
